import {logout, checkIfAdmin, message, getImageUrl} from '@/libs/helper'
import pageRoutes from '@/libs/constant/pageRoutes'
import constants from '@/libs/constant/constants'
import permissions from '@/libs/constant/permissions'
import { searchMeta, getActiveSubscription } from '@/libs/api/api'
import {concat} from 'lodash'
import ProfileCard from '@/components/component/Reuse/ProfileCard/ProfileCard.vue' 
// map gettters
import { mapGetters } from 'vuex'

export default{
    name: 'main-header',
    components:{ProfileCard},
    props: {
        userInformation: Object,
        isAnalytics: {
            type: Boolean,
            default: false
        },
        isInfo: {
            type: Boolean,
            default: false
        },
        organisationWithoutCollaborator: { 
            type: Array,
            default: () => []
        },
        selectedAccount: {
            type: Object,
            default: () => {}
        }
    },
    beforeCreate(){
        if(this.$route.path.includes('/ip/') || this.$route.path.includes('/dp/') || this.$route.path.includes('/su/') || this.$route.path.includes('/locations/') || this.$route.path.includes('/iam-dashboard/')){
            this.module = 'ip'
            this.isInfoPortal = true
        } else if (this.$route.path.includes('ap')) {
            this.module = 'ap'
            this.isInfoPortal = false
        } else if (this.$route.path.includes('/aa')) {
            this.module = 'aa'
            this.isInfoPortal = false
        }
    },
    beforeMount() {
        this.env = process.env.VUE_APP_ENV
    },
    updated () {
        this.env = process.env.VUE_APP_ENV
    },
    created(){
        this.getUserActiveSubscription()
    },
    data () {
        return {
            data: {
                isInfoPortal: false,
                module: 'ap',
                userInformation: this.userInformation
            },
            defaultProps: {
                userInformation: {}
            },
            isSearchActive: false,
            checkIfAdmin: checkIfAdmin,
            env: process.env.VUE_APP_ENV,
            searchFor: 'ALL',
            getImageUrl,
            searchInput: '',
            activeProfile: '',
            permissions: permissions
        }
    },
    computed:{
        ...mapGetters(['hasPermission', 'userSubscriptionExpired']),
        isInformationPortal () {
            return this.$route.path.includes('/ip/')
        },
        headerHeight() {
            if (this.module === 'aa' && !this.isInfo && this.userSubscriptionExpired) return '105px';
            if (this.module === 'aa' && !this.isInfo && !this.userSubscriptionExpired) return '60px';
            if (!this.isInfo && this.userSubscriptionExpired) return '160px';
            if (!this.isInfo && !this.userSubscriptionExpired) return '120px';
            if (this.isInfo && !this.userSubscriptionExpired) return '64px'
            else return '100px'
        }
    },
    watch: {
        '$route' (to) {
            if(to.path.includes('/ap/')) {
                this.setModule('ap')
                this.isInfoPortal = false
            } else if (to.path.includes('/ip/') || to.path.includes('/dp/') || to.path.includes('/su/') || to.path.includes('/locations/') || to.path.includes('/iam-dashboard/')) {
                this.setModule('ip')
                this.isInfoPortal = true
            }
        }
    },
    methods:{
        /*
        * returns the user to fetch the user's avatar.
        * */
        getURL(selectedAccount){
            if (selectedAccount && selectedAccount.avatar_image) {
                return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${selectedAccount.avatar_image}?auth=${localStorage.getItem('accuraAuthToken')}`
            } else {
                let avatarURL = require('@/assets/images/img_avatar.png')
                return avatarURL
            }
        },
        /*
        * return the place holder image in case of error in image loading.
        * */
        onError(e) {
            let avatarURL = require('../../../assets/images/img_avatar.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        /*
        * logout the user from accura account.
        * */
        logoutAccount(){
            logout(this)
            message(this, constants.messageType.SUCCESS, 'logout_successfully')
        },
        /*
         * handles the downloading command of the desktop app.
         * */
        downloadApp(downloadAppFor){
            const environment = process.env.VUE_APP_ENV === 'production' ? '' : process.env.VUE_APP_ENV === 'staging' ? '_staging' : '_development'
            switch (downloadAppFor){
                case 'MAC_OS':
                    window.open(`${process.env.VUE_APP_ELECTRON_APP_URL}/release/mac/Accura_Documents${environment}.dmg`)
                    break
                case 'WINDOWS_OS':
                    window.open(`${process.env.VUE_APP_ELECTRON_APP_URL}/release/windows/Accura_Documents.exe`)
                    break
            }
        },
        downloadEditorApp() {
            const environment = process.env.VUE_APP_ENV === 'production' ? '' : process.env.VUE_APP_ENV === 'staging' ? '_staging' : '_development'
            window.open(`${process.env.VUE_APP_EDITOR_APP_URL}/release/mac/Accura_Editor${environment}.dmg`)
        },
        /*
        * routes the user to my account page.
        * */
        routeToMyAccount(){
            this.$router.push({name: pageRoutes.account})
        },
        routeTo(command){
            const selectedAccount = this.selectedAccount || this.$store.getters.getSelectedAccount || {}
            switch (command){
                case 'OP_OVERVIEW':
                    this.setModule('ap')
                    this.$router.push(`${pageRoutes.home}/${pageRoutes.overview}`).catch(() => {})
                break
                case 'IP_OVERVIEW':
                    this.setModule('ip')
                    if (selectedAccount.type && selectedAccount.type === 'ORGANISATION') {
                        this.$router.push({name: pageRoutes.organisationOverview, params: {id: selectedAccount._id}}).catch(() => {})
                    } else {
                        this.$router.push({name: pageRoutes.usersOverview, params: {id: this.$store.getters.getUserInformation.id}}).catch(() => {})
                    }
                    
                break
                case 'SUBSCRIPTION':
                    this.setModule('ap')
                    this.$router.push(`${pageRoutes.home}/${pageRoutes.subscription}`).catch(() => {})
                break
                case 'ACCOUNT':
                    this.setModule('ap')
                    this.$router.push(`${pageRoutes.home}/${pageRoutes.account}`).catch(() => {})
                break
                case 'SECURITY':
                    this.setModule('ap')
                    this.$router.push(`${pageRoutes.home}/${pageRoutes.security}`).catch(() => {})
                break
                case 'COMMUNICATION':
                    this.setModule('ap')
                    this.$router.push(`${pageRoutes.home}/${pageRoutes.communication}`).catch(() => {})
                break
                case 'CARD':
                    this.setModule('ip')
                    this.$router.push(`${pageRoutes.ipHome}/${pageRoutes.card}`).catch(() => {})
                break
                case 'AUTHORS':
                    this.setModule('ip')
                    this.$router.push(`${pageRoutes.ipHome}/${pageRoutes.authors}`).catch(() => {})
                break
                case 'PUBLICATIONS':
                    this.setModule('ip')
                    this.$router.push(`${pageRoutes.ipHome}/${pageRoutes.publications}`)
                break
                case 'PUBLISHERS':
                    this.setModule('ip')
                    this.$router.push(`${pageRoutes.ipHome}/${pageRoutes.publishers}`).catch(() => {})
                break
                case 'ADMIN_PORTAL':
                    this.routeAdmin()
                break
                case 'DOWNLOAD':
                    if (navigator.appVersion.indexOf("Win")!=-1) this.downloadApp('WINDOWS_OS')
                    else if (navigator.appVersion.indexOf("Mac")!=-1) this.downloadApp('MAC_OS')
                break
                case 'DOWNLOAD_EDITOR':
                    if (navigator.appVersion.indexOf("Mac")!=-1) this.downloadEditorApp()
                break
                case 'DOCUMENTS_ONLINE':
                    window.open('http://de8cz8qk891a0.cloudfront.net/', '_blank')
                break
                case 'DEVELOPER_PORTAL':
                    window.open(process.env.VUE_APP_DEVELOPER_PORTAL, '_blank')
                break
                case 'DONATION_PORTAL':
                    this.setModule('ip')
                    this.$router.push({name: 'donations'}).catch(() => {})                    
                break
                case 'SHORT_URL':
                    this.setModule('ip')
                    this.$router.push({name: pageRoutes.shortURLSettingsRegisteredURL})
                break
                case 'LOCATION':
                    this.setModule('ip')
                    this.$router.push({name: pageRoutes.locationservice})
                break
                case 'IAM_DASHBOARD':
                    this.setModule('ip')
                    this.$router.push({name: pageRoutes.IAMMainDashboard}) 
                break
                case 'PUBLISHER':
                    this.setModule('ip')
                    this.$router.push({name: pageRoutes.publisherAPI})
            }
        },
        routeAdmin () {
            this.setModule('aa')
            let routeData = this.$router.resolve({name: 'info-overview'})
            window.open(routeData.href, '_blank')
        },
        /**
         * to set the module for header
         * @param {*} module 
         */
        setModule(module){
            this.module = module
        },
        /**
         * to route to card section
         */
        routeToCardSection () {
            this.$router.push({name: 'card'}).catch(() => {})
        },
        querySearch: async function (queryString, cb) {
            if(queryString === undefined || queryString === '' || queryString.length < 2){
                return
            }

            let searchResult = []
            let body = {
                search_text: queryString,
            }
            try{
                let param = constants.ADMIN[this.searchFor].value_without_s
                body.entity_type = param
                searchResult = await this.searchFollowers(body, param)
            }catch(error){
                return error
            }

            let listToDisplay = concat(searchResult.AUTHOR || [],searchResult.PUBLICATION || [], searchResult.PUBLISHER || [], searchResult.USER || searchResult.ORGANISATION || [])

            // call callback function to return suggestion objects
            cb(listToDisplay)
        },
        /**
         * redirect user to following pages
         * @param {*} record Object
         */
        routeToDetailPage(record){
            // for user to redirect the user on member page
            let self = this;
            switch (record.type) {
                case constants.ADMIN.Users.value_without_s:
                    this.$router.push({name: pageRoutes.usersOverview, params: {id: record._id}}).catch(() => {})
                break
                case constants.ORGANISATIONS.ORGANISATION:
                    this.$router.push({name: pageRoutes.organisationOverview, params: {id: record._id}}).catch(() => {})
                break
                default:
                    self.$router.push({name: `${record.type.toLowerCase()}-overview`, params: {id: record.publication || record._id}}).catch(() => {})
                break
            }
            this.clearFields()
        },
        setQuerySearch () {
            let route = this.$route
            if (route && (route.name === 'publications') || route.path.includes('/publication')) {
                this.searchFor = 'Publications'
            } else if (route && (route.name === 'authors' || route.path.includes('/author'))) {
                this.searchFor = 'Authors'
            } else if (route && (route.name === 'publishers') || route.path.includes('/publisher')) {
                this.searchFor = 'Publishers'
            } else {
                this.searchFor = 'ALL'
            }
        },
        searchFollowers (body) {
            return searchMeta(body).then((response) => {
                return response.items
            }).catch((error) => {
                return error
            })
        },
        /**
         * to change the input box
         */
        changeInput (e) {
            if (e) e.stopPropagation()
            this.isSearchActive = true
            this.$nextTick(() => {
                // this.$refs.search.$refs.input.focus()
                this.toCloseSearch()
            })
        },
        /**
         * to close the search item
         */
        toCloseSearch () {
            document.addEventListener('click', (evt) => {
                evt && evt.stopPropagation()
                const flyoutElement = document.getElementById('header-search')
                let targetElement = evt.target // clicked element
          
                do {
                  if (targetElement === flyoutElement) {
                    // This is a click inside. Do nothing, just return.
                    return
                  }
                  // Go up the DOM
                  targetElement = targetElement.parentNode
                } while (targetElement)
                    // to clear the fields if click outside
                    this.clearFields()
              })
        },
        /**
         * to clear the search field and hide the search bar
         */
        clearFields () {
            this.isSearchActive = false
            this.searchInput = ''
        },
        /*
         * getUserActiveSubscription() fetches the active plan of the user.
         * */
        async getUserActiveSubscription(){
            getActiveSubscription().then((response)=>{
                this.$store.dispatch('setExpiredSubscription', response.error)
            }).catch(()=>{
                // message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
    },
}
